<template>
    <b-modal id="modal-rincian" title="Hasil Perhitungan" size="lg" no-close-on-backdrop no-close-on-esc
        :hide-header-close="isSubmitting" :ok-title="isSubmitting ? 'Menghitung....' : 'Lanjutkan'"
        :ok-disabled="nilaiPinjaman == '' || isSubmitting" @ok.prevent="executeNext" @shown="focusInputPinjaman"
        cancel-title="Tutup">
        <div class="detail-data-wrapper mb-4">
            <h6 class="form-title mb-2">RINCIAN GADAI</h6>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Barang</b-col>
                <b-col>
                    <div v-if="rincian.namaBarang != null">
                        {{ rincian.namaBarang }}
                        <br>
                        <br>
                        {{ rincian.gosokCapKwitansi }}
                        <br>
                        <br>
                        {{ rincian.batuBarang }}
                    </div>
                    <div v-else>
                        {{ namaLengkapBarang }}
                    </div>
                </b-col>
            </b-row>
            <b-row v-if="!$helper.isNullOrEmpty(rincian.input) && !$helper.isNullOrEmpty(rincian.input.capEmas)" class="mb-2">
                <b-col cols="5" class="detail-data-label">Merk Cap Emas</b-col>
                <b-col class="detail-data-label">{{ rincian.input.capEmas.name }}</b-col>
            </b-row>
            <b-row v-if="!$helper.isNullOrEmpty(rincian.input) && !$helper.isNullOrEmpty(rincian.input.kemasanEmas)" class="mb-2">
                <b-col cols="5" class="detail-data-label">Jenis Kemasan Emas</b-col>
                <b-col class="detail-data-label">{{ rincian.input.kemasanEmas.name }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Spek Barang</b-col>
                <b-col>
                    <strong v-if="rincian.spekBarang == 2">RESMI</strong>
                    <strong v-else-if="rincian.spekBarang == 5">LN</strong>
                    <strong v-else>-</strong>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col v-if="rincian.detailBatu != null && rincian.detailBatu.length != 0" cols="5"
                    class="detail-data-label">Potongan Berat</b-col>
                <b-col>
                    <div v-for="item of rincian.detailBatu">
                        - {{ item }}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Harga Barang</b-col>
                <b-col>
                    Rp. {{ $helper.addThousandSeparator(rincian.hargaBarang) }}
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Kondisi - Grade {{ rincian.perhitunganKondisi.name }}</b-col>
                <b-col v-if="rincian.perhitunganKondisi.nominal < 0" class="text-danger">
                    Rp. {{ $helper.addThousandSeparator(rincian.perhitunganKondisi.nominal) }}
                </b-col>
                <b-col v-else>
                    Rp. {{ $helper.addThousandSeparator(rincian.perhitunganKondisi.nominal) }}
                </b-col>
            </b-row>
            <b-row class="mb-2" v-if="rincian.perhitunganBonusGadaiPertama != null">
                <b-col cols="5" class="detail-data-label">{{ rincian.perhitunganBonusGadaiPertama.name }}</b-col>
                <b-col>
                    Rp. {{ $helper.addThousandSeparator(rincian.perhitunganBonusGadaiPertama.nominal) }}
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Adjustment Status Anggota</b-col>
                <b-col v-if="rincian.perhitunganStatusAnggota.nominal < 0" class="text-danger">
                    Rp. {{ $helper.addThousandSeparator(rincian.perhitunganStatusAnggota.nominal) }}
                </b-col>
                <b-col v-else>
                    Rp. {{ $helper.addThousandSeparator(rincian.perhitunganStatusAnggota.nominal) }}
                </b-col>
            </b-row>
            <b-row class="mb-2" v-if="rincian.perhitunganAdjustmentSkemaDidepan != null">
                <b-col cols="5" class="detail-data-label">Adjustment Jasa Didepan</b-col>
                <b-col v-if="rincian.perhitunganAdjustmentSkemaDidepan < 0" class="text-danger">
                    Rp. {{ $helper.addThousandSeparator(rincian.perhitunganAdjustmentSkemaDidepan) }}
                </b-col>
                <b-col v-else>
                    Rp. {{ $helper.addThousandSeparator(rincian.perhitunganAdjustmentSkemaDidepan) }}
                </b-col>
            </b-row>
            <b-row class="mb-2" v-for="item in rincian.perhitunganPromo" v-bind:key="item.name">
                <b-col cols="5" class="detail-data-label">Promo: {{ item.name }}</b-col>
                <b-col v-if="item.nominal < 0" class="text-danger">
                    Rp. {{ $helper.addThousandSeparator(item.nominal) }}
                </b-col>
                <b-col v-else>
                    Rp. {{ $helper.addThousandSeparator(item.nominal) }}
                </b-col>
            </b-row>
        </div>
        <div class="detail-data-wrapper mb-4">
            <h6 class="form-title mb-2">RINCIAN SPESIFIKASI</h6>
            <div v-if="rincian.perhitunganSpek.length != 0">
                <b-row v-for="item in rincian.perhitunganSpek" v-bind:key="item.name" class="mb-2">
                    <b-col cols="5" class="detail-data-label">{{ item.name }}</b-col>
                    <b-col v-if="item.nominal < 0" class="text-danger">
                        Rp. {{ $helper.addThousandSeparator(item.nominal) }}
                    </b-col>
                    <b-col v-else>
                        Rp. {{ $helper.addThousandSeparator(item.nominal) }}
                    </b-col>
                </b-row>
            </div>
            <p v-else>Tidak ada</p>
        </div>
        <div class="detail-data-wrapper mb-4">
            <h6 class="form-title mb-2">PERHITUNGAN PINJAMAN</h6>
            <b-row class="mb-2" v-if="rincian.hargaMaksimalKondisi != null">
                <b-col cols="5" class="detail-data-label">Harga Maksimal Kondisi</b-col>
                <b-col>
                    Rp. {{ $helper.addThousandSeparator(rincian.hargaMaksimalKondisi) }}
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Pinjaman Maksimal</b-col>
                <b-col>
                    Rp. {{ $helper.addThousandSeparator(rincian.maksimumPinjaman) }}
                    <span class="smallText text-muted">
                        (Setelah Pembulatan)
                    </span>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Pinjaman Minimal</b-col>
                <b-col>
                    Rp. {{ $helper.addThousandSeparator(rincian.minimumPinjaman) }}
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Nilai Pinjaman</b-col>
                <b-col>
                    <b-input-group prepend="Rp.">
                        <b-form-input v-model="nilaiPinjaman" @focus="$event.target.select()" ref="inputNilaiPinjaman"
                            v-on:keyup.enter="executeNext" name="nilaiPinjaman" required></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Voucher Diskon</b-col>
                <b-col>
                    <b-input-group>
                        <b-input-group-prepend is-text>
                            <b-form-checkbox v-model="useVoucher" @change="onUseVoucherChange" />
                        </b-input-group-prepend>
                        <b-form-input v-model="voucherCode" :disabled="!useVoucher"></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="5" class="detail-data-label">Metode Pencairan</b-col>
                <b-col>
                    <b-form-group>
                        <b-form-select v-model="tunai">
                            <b-form-select-option :value="0">Tunai</b-form-select-option>
                            <b-form-select-option v-if="cashVirtual != false" :value="1">Non Tunai</b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
        </div>
        <div v-if="rekening != null">
            <b-row class="mb-2" :hidden="tunai != 1 ? true : false">
                <b-col cols="5" class="detail-data-label">Pilih Rekening</b-col>
                <b-col v-if="rekening.length != 0">
                    <b-form-group>
                        <b-form-select v-model="rekeningSelect">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Pilih Rekening --</b-form-select-option>
                            </template>
                            <b-form-select-option v-for="r in rekening" :value="r.id">
                                {{ r.noRekening }} - {{ r.namaRekening }} ({{ r.namaBank }})
                            </b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col v-else>
                    Nasabah tidak memiliki rekening
                </b-col>
            </b-row>
        </div>
        <b-alert variant="warning" class="mt-0" :show="rincian.isImeiBlacklisted">
            <strong>
                Perhatian!
            </strong>
            <br />
            IMEI ini di blacklist, harap cek terlebih dahulu.
        </b-alert>
        <b-alert :show="rincian.showAlertNoFakturGanda" variant="warning" class="my-4">
            <div>
                <strong>
                    Perhatian!
                </strong>
                <span v-if="rincian.alertGadai == 'kend'">
                    No. Polisi <strong>{{ rincian.alertNoPol }}</strong> atau No. Mesin
                    <strong>{{ rincian.alertNoMesin }}</strong> sudah digunakan pada No. Faktur
                    <strong>{{ rincian.alertNoFakturGanda }}</strong>!
                    Periksa kembali apabila sudah pernah digadaikan, lalu hubungi HO untuk pengecekan lebih lanjut!
                </span>
                <span v-else>
                    IMEI / SN <strong>{{ rincian.alertNoImei }}</strong> sudah digunakan pada No. Faktur
                    <strong>{{ rincian.alertNoFakturGanda }}</strong>!
                    Periksa kembali apabila barang ini sudah digadaikan!
                </span>
            </div>
        </b-alert>
        <b-alert :show="rincian.warnCpuZ == true" variant="primary" class="my-4">
            <div>
                <strong>
                    Perhatian! Cek Keaslian Android pada Device Info!
                </strong><br />

                Mohon pastikan sudah download aplikasi <strong> Device Info / Informasi Perangkat: CPU Sistem
                </strong>(Developer / Pengembang
                Aplikasi dengan nama <strong> Yasiru Nayanajith</strong>) dan mengikuti langkah-langkah sesuai SE terkait
                <strong> Perbedaan Handphone
                    / Tab Asli dan Palsu Khusus Android!</strong>
            </div>
        </b-alert>
      
    </b-modal>
</template>

<script>
export default {
    name: 'modal-rincian',
    props: {
        namaLengkapBarang: { type: String, required: true },
        isSubmitting: { type: Boolean, required: true },
        rincian: { type: Object, required: true },
        rekening: { type: Array },
        cashVirtual: { type: Boolean, required: true },
    },
    data() {
        return {
            nilaiPinjaman: "",
            voucherCode: "",
            useVoucher: false,
            tunai: 0,
            rekeningSelect: null,
        }
    },
    methods: {

        executeNext() {

            let pinjaman = this.$helper.removeThousandSeparator(this.nilaiPinjaman)

            if (pinjaman > this.rincian.maksimumPinjaman) {
                this.$helper.toastErr(this, "Nilai pinjaman melebihi maksimum!")
                return
            }

            if (pinjaman < this.rincian.minimumPinjaman) {
                this.$helper.toastErr(this, "Nilai pinjaman tidak mencapai minimum peminjaman!")
                return
            }

            if (this.tunai == 1) {
                if (this.rekeningSelect == null) {
                    this.$helper.toastErr(this, "Mohon pilih No. Rekening Nasabah!")
                    return
                }
            }

            let data = {
                nilaiPinjaman: pinjaman,
                useVoucher: this.useVoucher,
                voucherCode: this.voucherCode,
                tunai: this.tunai,
                rekeningSelect: this.rekeningSelect,
            }

            this.$emit("next", data)

        },
        focusInputPinjaman() {
            this.$refs.inputNilaiPinjaman.focus()
        },
          onUseVoucherChange(val) {
            if (!val) {
            this.voucherCode = '';
            }
          },

    },
    watch: {

        nilaiPinjaman: function (newValue) {

            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

            this.$nextTick(() => this.nilaiPinjaman = result)

        },

        "rincian.maksimumPinjaman": function (newValue) {
            this.nilaiPinjaman = this.$helper.addThousandSeparator(newValue)
            this.voucherCode = ""
            this.useVoucher = false
        },

        "this.rekeningSelect": function (newVal) {

            this.$emit("rekeningSelect", newVal)
        },

        "cashVirtual": function (newVal) {
            this.tunai = 0
            this.rekeningSelect = null
        },

        "rincian": function (newVal, oldVal) {
            if (this.$helper.isNullOrEmpty(this.rincian.noImei)) {
                this.rincian.noImei = oldVal.noImei
                this.rincian.spekBarang = oldVal.spekBarang
            }
        }

    }
}
</script>
